import CloseIcon from '@assets/images/icons/modal/close.svg?react'
import { setFinishedCrawlerJob } from '@storeOld/reducers/crawler'
import cx from 'classnames'
import { useDispatch } from 'react-redux'

import IconCheck from '@/lib/icons/IconCheck'
import type { CrawlerJobId, ImportSitemapData } from '@/types'
import status from '../CrawlerStatus.module.scss'
import { useCrawlerOpenJob } from '../hooks/useCrawlerOpenJob'
import { useCrawlerRemoveJob } from '../hooks/useCrawlerRemoveJob'
import css from './CrawlerSuccess.module.scss'

type CrawlerSuccessProps = {
  result: ImportSitemapData
  jobId: CrawlerJobId
}

const CrawlerSuccess: React.FC<CrawlerSuccessProps> = ({ result, jobId }) => {
  const { openJob } = useCrawlerOpenJob()
  const { remove, loading } = useCrawlerRemoveJob()
  const dispatch = useDispatch()

  const removeJob = async () => {
    await remove(jobId)
    // @todo move action
    // @ts-expect-error
    dispatch(setFinishedCrawlerJob(null))
  }

  return (
    <div className={cx(status.crawlerStatus, css.crawlerSuccess)}>
      <div className={status.crawlerStatusMain}>
        <div className={status.crawlerStatusIcon}>
          <IconCheck />
        </div>
        <div>
          <div>Crawl completed!</div>
          <div className={status.crawlerStatusDescription}>
            {result.extra.title}
          </div>
        </div>
      </div>
      <div
        onClick={() => openJob(result, jobId)}
        className={cx(status.crawlerStatusButton, css.crawlerSuccessButton)}
      >
        Open project
      </div>
      <button
        disabled={loading}
        onClick={removeJob}
        className={css.crawlerSuccessClose}
      >
        <CloseIcon />
      </button>
    </div>
  )
}

export default CrawlerSuccess
